import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import styles from './ki-ds-pwa-timeseries-location-group.css';
import '../ki-ds-pwa-timeseries-list-item/ki-ds-pwa-timeseries-list-item';

const CLASS_NAME = 'ki-ds-pwa-timeseries-location-group';

@customElement(CLASS_NAME)
export class KiDsPwaTimeseriesLocationGroup extends KiDsPwaComponent {
    static styles = styles;

    _className = CLASS_NAME;

    static get properties() {
        return {
            location: { type: String },
            timeseries: { type: Array },
            staggerOffset: { type: Number },
            selectedIds: { type: Array },
            selectable: { type: Boolean },
            alarmStatusList: { type: Array },
            alarmConfigs: { type: Array },
            classificationTemplate: { type: Object },
            parameters: { type: Object },
            _animated: { type: Boolean, state: true },
        };
    }

    constructor() {
        super();
        this.location = '';
        this.timeseries = [];
        this.staggerOffset = 0;
        this.selectedIds = [];
        this.selectable = true;
        this.alarmStatusList = [];
        this.alarmConfigs = [];
        this.classificationTemplate = null;
        this.parameters = null;
        this._animated = false;
    }

    firstUpdated() {
        super.firstUpdated();
        setTimeout(() => {
            this._animated = true;
        }, 1500);
    }

    render() {
        return html`
            <div class=${classMap({ group: true, animated: this._animated })}>
                <div class="location-title">${this.location}</div>
                <div class="items">${this.timeseries.map((ts, i) => this._renderItem(ts, i))}</div>
            </div>
        `;
    }

    _renderItem(ts, i) {
        const alarmStatus = this.alarmStatusList?.find((s) => s.tsId === ts.id);
        const alarmConfig = this.alarmConfigs?.find((c) => c.tsId === ts.id);
        const selected = this.selectedIds.includes(ts.id);

        return html`
            <ki-ds-pwa-timeseries-list-item
                style=${styleMap({ '--i': this.staggerOffset + i })}
                .timeseries=${ts}
                .alarmStatus=${alarmStatus}
                .alarmConfig=${alarmConfig}
                .parameters=${this.parameters}
                .classificationTemplate=${this.classificationTemplate}
                .selected=${selected}
                .selectable=${this.selectable}
            ></ki-ds-pwa-timeseries-list-item>
        `;
    }
}
